import {
    Component,
    EventEmitter,
    Inject,
    Input,
    OnInit,
    Output,
    ViewChild,
    ViewContainerRef,
  } from "@angular/core";
  import {
    DataStateChangeEventArgs,
    DetailRowService,
    GridComponent,
    GridModel,
  } from "@syncfusion/ej2-angular-grids";
  import { GlobalComponent } from "src/app/global/global.component";
  import {
    GetScheduleBo,
    ScheduleEventEmitterBo,
    UpdateAppointmentUpdateBO,
    functionpermission,
  } from "../schedule.modal";
  import { Observable, Subject } from "rxjs";
  import { ToastrService } from "ngx-toastr";
  import { ScheduleService } from "../schedule.service";
  import { CommonHttpService } from "src/app/common.service";
  import { DateService } from "src/app/date.service";
  import { DatePipe } from "@angular/common";
  import { ScheduleListService } from "./schedule-list.service";
  import { ScheduleEditService } from "../schedule-edit/schedule-edit.service";
  import { ClientHttpService } from "../../client-parent/client-parent.service";
  import { IMyDpOptions } from "mydatepicker";
  import { ColumnChangeBO, columnWidth } from "../../employee/employee.model";
  import { WhereCondition } from "../../client-parent/client-parent.model";
  import { takeUntil } from "rxjs/operators";
import { HttpErrorResponse } from "@angular/common/http";
  
  @Component({
    selector: "app-schedule-list",
    templateUrl: "./schedule-list.component.html",
    styleUrls: ["./schedule-list.component.scss"],
    providers: [DetailRowService],
  })
  export class ScheduleListComponent implements OnInit {
   
    locationID: string = '00000000-0000-0000-0000-000000000000';
    scheduleRadioType: any = "";
    ScheduleData: any = [];
    showDays: boolean = false;
    ListEndDate: any = "";
    DeleteType: any;
    visitscheduleId: any;
    ListValidationDate: any;
    ListStartDate: any = "";
    ClientDropdown: any = [];
    EmployeeDropdown: any = [];
    AuthorizationDetails: any = [];
    clientName: string = "";
    employeeName: string = "";
    startDate: string = "";
    endDate: string = "";
    ListUpdateClientId: any;
    ListUpdateEmployeeId: any;
    ListUpdateserviceGroupId: any;
    serviceGroupName: string = "";
    frequency: any = "";
    retainFieldList: any;
    DeleteStartDate: any;
    DeleteEndDate: any;
    ListUpdateEndDate: any;
    ListUpdateStartDate: any;
    childEjsScheduleGrid: GridModel;
    updateAppointmentUpdateBO: UpdateAppointmentUpdateBO =
      new UpdateAppointmentUpdateBO();
    @Input() ListScheduleInputProperty: ScheduleEventEmitterBo =
      new ScheduleEventEmitterBo();
    @Output() ListOutputSchedule = new EventEmitter<ScheduleEventEmitterBo>();
    @ViewChild("gridSchedule") public gridSchedule: GridComponent;
    ScheduleList: any = [];
    arraycol: any = [];
    type: string = "";
    id: number =0;
    @ViewChild("gridAuthDetails") public gridAuthDetails: GridComponent;
    AppointmentId: any;
    ListEmployeeId: any;
    MappedEmployeeDropdown: any = [];
    MappedServiceGroupDropdown: any = [];
    ListClientId: any;
    columnchange: ColumnChangeBO = new ColumnChangeBO();
    private onDestroy$: Subject<void> = new Subject<void>();
    ColumnsSchedule: columnWidth[];
    conditionlist: WhereCondition[] = [];
    getFilterBo: GetScheduleBo = new GetScheduleBo();
    public GridDataList: Observable<DataStateChangeEventArgs>;
    public filterSettings: object;
    initialPage: object;
    checkScheduleType: string = ";";
    formatOptions: object;
    public PastandFutureOption: IMyDpOptions = {
      dateFormat: "mm/dd/yyyy",
      disableUntil: {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        day: new Date().getDate() - 1,
      },
      showClearDateBtn: false,
      editableDateField: true,
    };
    @ViewChild("childtemplate") public childtemplate: any;
    fp: functionpermission = new functionpermission();
    IsButtonDisable: boolean = false;
    constructor(
      public ClientService: ClientHttpService,
      public EditService: ScheduleEditService,
      public ListService: ScheduleListService,
      public dateservice: DateService,
      public datePipe: DatePipe,
      public commonservice: CommonHttpService,
      public toasterService: ToastrService,
      public global: GlobalComponent,
      public getList: ScheduleService,
      @Inject(ViewContainerRef) private viewContainerRef?: ViewContainerRef
    ) {
      this.GridDataList = getList;
    }
    ngAfterViewInit() {
      this.childtemplate.elementRef.nativeElement._viewContainerRef =
        this.viewContainerRef;
      this.childtemplate.elementRef.nativeElement.propName = "template";
    }
    ngOnInit(): void {
   
      this.formatOptions = { type: "date", format: "MM/dd/yyyy" };
      this.filterSettings = { type: "Menu" };
      if (
        this.global.globalAgencyId == null ||
        this.global.globalAgencyId == "" ||
        this.global.globalAgencyId == undefined ||
        this.global.globalAgencyId == '00000000-0000-0000-0000-000000000000'
      ) {
        return;
      }
      // let SchedulePage = JSON.parse(this.global.globalColumn.column)[0]
        // .Appointment.Pagesize;
      this.ListStartDate =
        new Date().getMonth() +
        1 +
        "/" +
        new Date().getDate() +
        "/" +
        new Date().getFullYear();
      this.ListEndDate =
        new Date().getMonth() +
        1 +
        "/" +
        new Date().getDate() +
        "/" +
        new Date().getFullYear();
      this.initialPage = {
        currentPage: 1,
        pageSizes: ["10", "15", "20", "50", "100", "250"],
        pageSize: 10,
      };
      if (
        this.global.globalLocationId != null &&
        this.global.globalLocationId != "" &&
        this.global.globalLocationId != undefined
      ) {
        this.locationID = this.global.globalLocationId;
      } else {
        this.locationID = '00000000-0000-0000-0000-000000000000';
      }
      this.childEjsScheduleGrid = {
        dataSource: this.ScheduleData,
        queryString: "visitScheduleId",
        allowSorting: false,
        allowPaging: false,
        load() {
          this.registeredTemplate = {};
        },
        columns: [
          {
            field: "Edit",
            headerText: "Edit",
            width: 50,
            template: this.childtemplate,
          },
          { field: "appointmentDate", headerText: "Schedule Dates", width: 75 },
          { field: "setstartTime", headerText: "Start Time", width: 75 },
          { field: "setendTime", headerText: "End Time", width: 75 },
          { field: "appointmentDay", headerText: "Schedule Days", width: 75 },
          { field: "hours", headerText: "Hours", width: 100 },
          { field: "isViststarted", headerText: "Evv Status", width: 80 },
        ],
      };
      this.getCustomFrequency();
      this.GetClientsDropDownbyAgency();
      this.GetAllEmployeesDropDownbyAgency();
      if (this.ListScheduleInputProperty.isClose == false) {
        this.ApplyFilter();
      }
      this.getpermission();
    }

    getpermission() {
      if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId!=null&&this.global.globalAgencyId!=undefined&&this.global.globalAgencyId!='')) {
      let params = new URLSearchParams();
      params.append("pagecode", "Schedule");
      params.append("roleId", this.global.roleId);
      params.append("agencyId", this.global.globalAgencyId)
      this.commonservice.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        if (data != null && Object.keys(data).length > 0) {
          this.fp = data;
        }
        else {
          this.fp = new functionpermission();
        }
      },
        (err: HttpErrorResponse) => {
          this.fp = new functionpermission();
        })
      }
    }
    //.....................................................onActionComplete...............................................
    public onActionComplete(args) {
      if (args.requestType == "columnstate") {
        let hidearr = [];
        let showarr = [];
        this.gridSchedule.columns.forEach((element) => {
          if (
            element.visible == false &&
            element.headerText != "Actions" &&
            element.headerText != ""
          ) {
            hidearr.push(element.headerText);
          }
          if (
            element.visible == true &&
            element.headerText != "Actions" &&
            element.headerText != ""
          ) {
            showarr.push(element.headerText);
          }
        });
        var count = 0;
        var count1 = 0;
        if (args.columns.length > 0) {
          if (this.arraycol.length > 0) {
            this.arraycol[0].Appointment.ShowColumns.forEach((old) => {
              showarr.forEach((element) => {
                if (old == element) {
                  count1 = count1 + 1;
                }
              });
            });
            this.arraycol[0].Appointment.HideColumns.forEach((old) => {
              hidearr.forEach((element) => {
                if (old == element) {
                  count = count + 1;
                }
              });
            });
            if (
              this.arraycol[0].Appointment.ShowColumns.length != count1 ||
              this.arraycol[0].Appointment.HideColumns.length != count
            ) {
              this.arraycol[0].Appointment.ShowColumns = showarr;
              this.arraycol[0].Appointment.HideColumns = hidearr;
              this.SaveColumnwidth();
            }
          }
        }
      }
      this.getFilterBo.currentpageno =
        this.gridSchedule.pagerModule.pagerObj.currentPage;
      this.getFilterBo.pageitem = this.gridSchedule.pagerModule.pagerObj.pageSize;
      this.conditionlist = [];
      if (args.requestType === "filtering" && args.action === "filter") {
        args.columns.forEach((element) => {
          this.conditionlist.push(element.properties);
        });
      }
      if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
        this.getFilterBo.type = args.columnType;
      }
    }
    //.....................................................ApplyFilter...............................................
    ApplyFilter() {
      if (
        this.ListEmployeeId == null ||
        this.ListEmployeeId == "" ||
        this.ListEmployeeId == undefined
      ) {
        this.ListEmployeeId = '00000000-0000-0000-0000-000000000000';
        this.getFilterBo.employeeId = '00000000-0000-0000-0000-000000000000';
      } else {
        this.getFilterBo.employeeId = this.ListEmployeeId;
      }
      if (
        this.ListClientId == null ||
        this.ListClientId == "" ||
        this.ListClientId == undefined
      ) {
        this.ListClientId = '00000000-0000-0000-0000-000000000000';
        this.getFilterBo.clientId = '00000000-0000-0000-0000-000000000000';
      } else {
        this.getFilterBo.clientId = this.ListClientId;
      }
     
      if (
        this.ListStartDate != null &&
        this.ListStartDate != undefined &&
        this.ListStartDate != ""
      ) {
        this.getFilterBo.startDate = this.global.getDateTimeString(
          this.ListStartDate
        );
      }
      if (
        this.ListEndDate != null &&
        this.ListEndDate != undefined &&
        this.ListEndDate != ""
      ) {
        this.getFilterBo.endDate = this.global.getDateTimeString(
          this.ListEndDate
        );
      }
      if (
        (this.getFilterBo.startDate == null ||
          this.getFilterBo.startDate == "" ||
          this.getFilterBo.startDate == undefined) &&
        this.getFilterBo.endDate != null &&
        this.getFilterBo.endDate != "" &&
        this.getFilterBo.endDate != undefined
      ) {
        this.toasterService.error("Please select start date");
        return;
      }
      if (
        this.getFilterBo.startDate != null &&
        this.getFilterBo.startDate != "" &&
        this.getFilterBo.startDate != undefined &&
        this.getFilterBo.endDate != null &&
        this.getFilterBo.endDate != "" &&
        this.getFilterBo.endDate != undefined
      ) {
        if (
          new Date(this.getFilterBo.startDate).getTime() >
          new Date(this.getFilterBo.endDate).getTime()
        ) {
          this.toasterService.error("End date should greater than start date");
          return;
        }
      }
      this.getScheduleFilter();
    }
    //.....................................................Refresh...............................................
    Refresh() {
      this.gridSchedule.clearFiltering();
      this.gridSchedule.clearSorting();
      this.getFilterBo = new GetScheduleBo();
      this.updateAppointmentUpdateBO = new UpdateAppointmentUpdateBO();
      this.ListClientId = null;
      this.ListEmployeeId = null;
      this.ListStartDate =
        new Date().getMonth() +
        1 +
        "/" +
        new Date().getDate() +
        "/" +
        new Date().getFullYear();
      this.ListEndDate =
        new Date().getMonth() +
        1 +
        "/" +
        new Date().getDate() +
        "/" +
        new Date().getFullYear();
      this.ApplyFilter();
    }
    //.....................................................getServiceName...............................................
    getServiceName() {
      let serviceName = this.MappedServiceGroupDropdown?.filter(
        (a) => a.clientServiceId == this.updateAppointmentUpdateBO.serviceGroupId
      )[0];
  
      this.serviceGroupName = serviceName.serviceGroupName;
    }
    //................................................... dataStateChange.................................................
    public dataStateChange(state): void {
      this.type = state.action.requestType.toString();
      if (this.type != "filterchoicerequest") {
        if ((state.sorted || []).length) {
          this.getFilterBo.orderColumn = state.sorted[0].name;
          this.getFilterBo.orderType =
            state.sorted[0].direction === "descending" ? "desc" : "asc";
        }
      }
      if (this.type == "filtering" && state.action.action != "clearFilter") {
        this.getFilterBo.field = state.action.currentFilterObject.field;
        this.getFilterBo.matchCase = state.action.currentFilterObject.matchCase;
        this.getFilterBo.operator = state.action.currentFilterObject.operator;
        this.getFilterBo.value = state.action.currentFilterObject.value;
        if (this.getFilterBo.type == "number") {
          this.getFilterBo.value =
            state.action.currentFilterObject.value.toString();
          this.getFilterBo.field = state.action.currentFilterObject.field;
        } else if (this.getFilterBo.type == "datetime") {
          this.getFilterBo.value = this.global.getDateTimeString(
            state.action.currentFilterObject.value
          );
          this.getFilterBo.field = state.action.currentFilterObject.field;
        } else {
          this.getFilterBo.value = state.action.currentFilterObject.value;
          this.getFilterBo.field = state.action.currentFilterObject.field;
        }
        this.getFilterBo.matchCase = state.action.currentFilterObject.matchCase;
        this.getFilterBo.operator = state.action.currentFilterObject.operator;
      } else {
        if (this.type == "filtering" && state.action.action == "clearFilter") {
          this.getFilterBo.field = "clientName";
          this.getFilterBo.matchCase = false;
          this.getFilterBo.operator = "startswith";
          this.getFilterBo.value = "";
          this.getFilterBo.type = "string";
        }
      }
      if (this.type != "refresh") {
        this.ApplyFilter();
      }
      if (this.type == "paging" && state.action.name == "actionBegin") {
        if (this.arraycol.length != 0) {
          if (this.arraycol[0].Appointment.Pagesize != state.take) {
            this.arraycol[0].Appointment.Pagesize = state.take;
          }
        }
        this.SaveColumnwidth();
      }
    }
    //.............................................onResize.................................................................
    onResize(args) {
      const column = this.gridSchedule.getColumnByField(args.column.field);
      column.width = args.column.width;
      this.gridSchedule.refreshHeader();
      this.ColumnsSchedule.forEach((element) => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
      this.SaveColumnwidth();
    }
    //......................................SaveColumnwidth....................................................................
    SaveColumnwidth() {
      this.arraycol[0].Appointment.Columns = this.ColumnsSchedule;
      this.arraycol[0].Appointment.Pagesize =
        this.gridSchedule.pageSettings.pageSize;
      this.columnchange.userid = parseInt(this.global.userID);
      this.columnchange.column = JSON.stringify(this.arraycol);
      this.columnchange.id = this.id;
      this.global.globalColumn = this.columnchange;
      this.arraycol = JSON.parse(this.global.globalColumn.column);
      // this.ClientService.savecolumnwidth(this.columnchange)
      //   .pipe(takeUntil(this.onDestroy$))
      //   .subscribe((data: any) => {});
    }
  
    //......................................getScheduleFilter....................................................................
    getScheduleFilter() {
      this.getList.execute(this.getFilterBo);
      this.GridDataList.pipe(takeUntil(this.onDestroy$)).subscribe(
        (data: any) => {
          this.ScheduleList = data.result;
          this.ScheduleData = this.getList.getChildGridList();
  
          if (data != null && data != undefined) {
            // this.getColumnwidth();
          }
          if (data != null && data != undefined && data.result.length > 15) {
            this.gridSchedule.height = "500";
          } else {
            this.gridSchedule.height = "auto";
          }
          this.childEjsScheduleGrid = {
            dataSource: this.ScheduleData,
            queryString: "visitScheduleId",
            allowSorting: false,
            allowPaging: false,
            load() {
              this.registeredTemplate = {};
            },
            editSettings: {
              allowEditing: false,
              allowAdding: false,
              allowDeleting: false,
            },
            columns: [
              {
                field: "Edit",
                headerText: "Edit",
                width: 50,
                template: this.childtemplate,
              },
              {
                field: "appointmentDate",
                headerText: "Schedule Dates",
                width: 75,
              },
              { field: "setstartTime", headerText: "Start Time", width: 75 },
              { field: "setendTime", headerText: "End Time", width: 75 },
              { field: "appointmentDay", headerText: "Schedule Days", width: 75 },
              { field: "hours", headerText: "Hours", width: 100 },
              { field: "isViststarted", headerText: "Evv Status", width: 80 },
            ],
          };
        }
      );
    }
    // ...........................................showorHideColumns.............................................................
    showorHideColumns() {
      this.gridSchedule.columnChooserModule.openColumnChooser(200, 50); // give X and Y axis
    }
    //......................................getColumnwidth....................................................................
    getColumnwidth() {
      this.arraycol = JSON.parse(this.global.globalColumn.column);
      this.ColumnsSchedule = this.arraycol[0].Appointment.Columns;
      this.gridSchedule.hideColumns(this.arraycol[0].Appointment.HideColumns);
      if (
        this.global.globalColumn.userid != null &&
        this.global.globalColumn.agencyId != null
      ) {
        this.id = this.global.globalColumn.id;
      }
      this.gridSchedule.pageSettings.pageSize =
        this.arraycol[0].Appointment.Pagesize;
      this.ColumnsSchedule.forEach((element) => {
        // Actions
        if (element.column == "Actions") {
          const column2 = this.gridSchedule.getColumnByUid("action");
          column2.headerText = element.column;
          column2.width = element.width;
          this.gridSchedule.refreshHeader();
        }
        // Client
        if (element.column == "Client") {
          const column = this.gridSchedule.getColumnByField("clientName");
          column.headerText = element.column;
          column.width = element.width;
          this.gridSchedule.refreshHeader();
        }
        // Employee
        if (element.column == "Employee") {
          const column = this.gridSchedule.getColumnByField("employeeName");
          column.headerText = element.column;
          column.width = element.width;
          this.gridSchedule.refreshHeader();
        }
        // Start Date
        if (element.column == "Start Date") {
          const column = this.gridSchedule.getColumnByField("startDate");
          column.headerText = element.column;
          column.width = element.width;
          this.gridSchedule.refreshHeader();
        }
        // End Date
        if (element.column == "End Date") {
          const column = this.gridSchedule.getColumnByField("endDate");
          column.headerText = element.column;
          column.width = element.width;
          this.gridSchedule.refreshHeader();
        }
        // Total hours
        if (element.column == "Total hours") {
          const column = this.gridSchedule.getColumnByField("totalhours");
          column.headerText = element.column;
          column.width = element.width;
          this.gridSchedule.refreshHeader();
        }
        // Service
        if (element.column == "Service") {
          const column = this.gridSchedule.getColumnByField("serviceGroupName");
          column.headerText = element.column;
          column.width = element.width;
          this.gridSchedule.refreshHeader();
        }
        // Frequency Type
        if (element.column == "Frequency Type") {
          const column = this.gridSchedule.getColumnByField("frequencyDays");
          column.headerText = element.column;
          column.width = element.width;
          this.gridSchedule.refreshHeader();
        }
        // Days
        if (element.column == "Days") {
          const column = this.gridSchedule.getColumnByField("scheduleWeekDays");
          column.headerText = element.column;
          column.width = element.width;
          this.gridSchedule.refreshHeader();
        }
        // Start Time
        if (element.column == "Start Time") {
          const column = this.gridSchedule.getColumnByField("setstartTime");
          column.headerText = element.column;
          column.width = element.width;
          this.gridSchedule.refreshHeader();
        }
        // End Time
        if (element.column == "End Time") {
          const column = this.gridSchedule.getColumnByField("setendTime");
          column.headerText = element.column;
          column.width = element.width;
          this.gridSchedule.refreshHeader();
        }
      });
    }
    //......................................GetClientsDropDownbyAgency....................................................................
    GetClientsDropDownbyAgency() {
      this.commonservice
        .GetAllClientDropDown()
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((data: any[]) => {
          this.ClientDropdown = data;
        });
    }
    //......................................GetAllEmployeesDropDownbyAgency....................................................................
    GetAllEmployeesDropDownbyAgency() {
      this.commonservice
        .GetAllEmployeesDropdown()
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((data: any[]) => {
          this.EmployeeDropdown = data;
        });
    }
    // ................................................EmitToEditpage...................................................
    EmitToEditpage() {
      this.ListOutputSchedule.emit({
        isCreate: true,
        isClose: false,
        ClientDropdown: this.ClientDropdown,
        CustomFrequencyList: this.ListScheduleInputProperty.CustomFrequencyList,
      });
    }
    // ................................................Schedulenewdates...................................................
    Schedulenewdates(event, type, name) {
      if (type == "inputchanged") {
        if (name == "ListStart") {
          let val = this.dateservice.inputFeildchange(event);
          if (val != undefined) {
            let val1 = this.dateservice.inputFeildchange(event);
            this.ListStartDate = val1;
          }
        }
        if (name == "ListEnd") {
          let val = this.dateservice.inputFeildchange(event);
          if (val != undefined) {
            let val1 = this.dateservice.inputFeildchange(event);
            this.ListEndDate = val1;
          }
        }
  
        if (name == "ScheduleStart") {
          let val = this.dateservice.inputFeildchange(event);
          if (val != undefined) {
            let val1 = this.dateservice.inputFeildchange(event);
            this.startDate = val1;
          }
        }
        if (name == "ScheduleEnd") {
          let val = this.dateservice.inputFeildchange(event);
          if (val != undefined) {
            let val1 = this.dateservice.inputFeildchange(event);
            this.endDate = val1;
          }
        }
  
        if (name == "ScheduleDeleteStart") {
          let val = this.dateservice.inputFeildchange(event);
          if (val != undefined) {
            let val1 = this.dateservice.inputFeildchange(event);
            this.DeleteStartDate = val1;
          }
        }
        if (name == "ScheduleDeleteEnd") {
          let val = this.dateservice.inputFeildchange(event);
          if (val != undefined) {
            let val1 = this.dateservice.inputFeildchange(event);
            this.DeleteEndDate = val1;
          }
        }
      }
      if (type == "datechanged") {
        if (name == "ListStart") {
          let value = this.dateservice.Datechange(event);
          if (value != undefined) {
            let val = this.dateservice.Datechange(event);
            this.ListStartDate = val;
            this.getValidationDate();
            this.clearListValidationDate();
          }
        }
        if (name == "ListEnd") {
          let value = this.dateservice.Datechange(event);
          if (value != undefined) {
            let val = this.dateservice.Datechange(event);
            this.ListEndDate = val;
            this.clearListValidationDate();
          }
        }
        if (name == "ScheduleStart") {
          let value = this.dateservice.Datechange(event);
          if (value != undefined) {
            let val = this.dateservice.Datechange(event);
            this.startDate = val;
          }
        }
        if (name == "ScheduleEnd") {
          let value = this.dateservice.Datechange(event);
          if (value != undefined) {
            let val = this.dateservice.Datechange(event);
            this.endDate = val;
          }
        }
        if (name == "ScheduleDeleteStart") {
          let value = this.dateservice.Datechange(event);
          if (value != undefined) {
            let val = this.dateservice.Datechange(event);
            this.DeleteStartDate = val;
          }
        }
        if (name == "ScheduleDeleteEnd") {
          let value = this.dateservice.Datechange(event);
          if (value != undefined) {
            let val = this.dateservice.Datechange(event);
            this.DeleteEndDate = val;
          }
        }
      }
    }
  
    // ..........................................................getValidationDate..........................................................
    getValidationDate() {
      var StartDate = new Date(this.ListStartDate);
      let setDate = StartDate.setDate(StartDate.getDate() + 365);
      let getDate = setDate;
      this.ListValidationDate = this.datePipe.transform(getDate, "MM/dd/yyyy");
    }
    // ................................................clearListValidationDate...................................................
    clearListValidationDate() {
      if (
        this.ListStartDate != null &&
        this.ListStartDate != undefined &&
        this.ListStartDate != "" &&
        this.ListEndDate != null &&
        this.ListEndDate != undefined &&
        this.ListEndDate != ""
      ) {
        let EndDate = this.datePipe.transform(this.ListEndDate, "MM/dd/yyyy");
        if (
          new Date(EndDate).getTime() >
          new Date(this.ListValidationDate).getTime()
        ) {
          this.toasterService.error(
            "Date range should not be greater than 1 year"
          );
          this.ListEndDate = null;
          setTimeout(() => {
            this.toasterService.clear();
          }, 3000);
        }
        if (
          this.ListEndDate != null &&
          this.ListEndDate != undefined &&
          this.ListEndDate != ""
        ) {
          if (
            new Date(this.ListStartDate).getTime() >
            new Date(this.ListEndDate).getTime()
          ) {
            this.ListEndDate = null;
  
            this.toasterService.error("end time should greater than start time");
            setTimeout(() => {
              this.toasterService.clear();
            }, 3000);
            return;
          }
        }
      }
    }
    //......................................editSchedule....................................................................
    editSchedule(schedulerecords, type) {
      this.scheduleRadioType = "enterseries";
      this.checkScheduleType = type;
      this.updateAppointmentUpdateBO = JSON.parse(
        JSON.stringify(schedulerecords)
      );
  
      this.retainFieldList = JSON.parse(JSON.stringify(schedulerecords));
  
      this.updateAppointmentUpdateBO.clientId =
        schedulerecords.clientId != null
          ? schedulerecords.clientId
          : '00000000-0000-0000-0000-000000000000';
  
      if (schedulerecords.clientId != '00000000-0000-0000-0000-000000000000' && type == "parentgrid") {
        this.getEmployeeRelationsip("updated");
      }
      if (schedulerecords.employeeId != '00000000-0000-0000-0000-000000000000' && type == "parentgrid") {
        this.getClientServiceDropdown("updated");
      }
      this.convertingDays(schedulerecords);
      this.updateAppointmentUpdateBO.startTime = schedulerecords.startTime;
      this.updateAppointmentUpdateBO.endTime = schedulerecords.endTime;
      this.clientName = schedulerecords.clientName;
      this.employeeName = schedulerecords.employeeName;
      this.startDate =
        schedulerecords.startDate != null
          ? this.datePipe.transform(schedulerecords.startDate, "MM/dd/yyyy")
          : null;
      this.endDate =
        schedulerecords.endDate != null
          ? this.datePipe.transform(schedulerecords.endDate, "MM/dd/yyyy")
          : null;
      this.updateAppointmentUpdateBO.employeeId =
        schedulerecords.employeeId != null
          ? schedulerecords.employeeId
          : '00000000-0000-0000-0000-000000000000';
  
      
      this.updateAppointmentUpdateBO.updateCustomFrequencyLid =
        schedulerecords.customFrequencyLid != null
          ?schedulerecords.customFrequencyLid
          : '00000000-0000-0000-0000-000000000000';
      this.serviceGroupName = schedulerecords.serviceGroupName;
      this.frequency = schedulerecords.frequencyDays;
      this.getAuthDetails(schedulerecords.clientId);
      this.ListUpdateClientId = schedulerecords.clientId;
      this.ListUpdateEmployeeId = schedulerecords.employeeId;
      this.ListUpdateserviceGroupId = schedulerecords.serviceGroupId;
  
      this.ListUpdateStartDate =
        schedulerecords.startDate != null
          ? this.datePipe.transform(schedulerecords.startDate, "MM/dd/yyyy")
          : null;
      this.ListUpdateEndDate =
        schedulerecords.endDate != null
          ? this.datePipe.transform(schedulerecords.endDate, "MM/dd/yyyy")
          : null;
    }
    // ................................................UpdateScheduleAppointment...................................................
    UpdateScheduleAppointment() {
      this.IsButtonDisable = true;
      let updateScheduleAppointment = JSON.parse(
        JSON.stringify(this.updateAppointmentUpdateBO)
      );
      updateScheduleAppointment.startDate =
        this.checkScheduleType == "parentgrid"
          ? this.startDate
          : updateScheduleAppointment.appointmentDate;
      updateScheduleAppointment.endDate =
        this.checkScheduleType == "parentgrid"
          ? this.endDate
          : updateScheduleAppointment.appointmentDate;
      var currentdate: any = new Date();
      let conversion = this.global.getDateTimeString(currentdate);
  
      if (
        new Date(conversion).getDate() ==
        new Date(updateScheduleAppointment.startDate).getDate()
      ) {
        let startTime =
          updateScheduleAppointment.startTime != null &&
          updateScheduleAppointment.startTime != undefined &&
          updateScheduleAppointment.startTime != ""
            ? new Date(
                updateScheduleAppointment.startDate +
                  " " +
                  updateScheduleAppointment.startTime
              )
            : this.global.getDateTimeString(new Date()).toString();
        currentdate = this.datePipe.transform(currentdate, "yyyy-MM-dd'T'HH:mm");
        startTime = this.datePipe.transform(startTime, "yyyy-MM-dd'T'HH:mm");
        if (new Date(startTime).getTime() < new Date(currentdate).getTime()) {
          this.IsButtonDisable = false;
          this.toasterService.error("Past Timings are not allowed");
          return;
        }
      }
      if (
        new Date(conversion).getDate() ==
        new Date(updateScheduleAppointment.endDate).getDate()
      ) {
        let endTime =
          updateScheduleAppointment.endTime != null &&
          updateScheduleAppointment.endTime != undefined &&
          updateScheduleAppointment.endTime != ""
            ? new Date(
                updateScheduleAppointment.startDate +
                  " " +
                  updateScheduleAppointment.endTime
              )
            : this.global.getDateTimeString(new Date()).toString();
        if (new Date(endTime).getTime() < new Date(currentdate).getTime()) {
          this.IsButtonDisable = false;
          this.toasterService.error("Past Timings are not allowed");
          return;
        }
      }
      var PastDates:any=this.datePipe.transform(new Date(currentdate),"MM/dd/yyyy")
      if (new Date(PastDates).getTime() >new Date(updateScheduleAppointment.startDate).getTime() || new Date(PastDates).getTime() >new Date(updateScheduleAppointment.endDate).getTime() ) {
        this.IsButtonDisable = false;
        this.toasterService.error("Past dates are not allowed");
        return;
      }
      let startTime =
        this.checkScheduleType == "parentgrid"
          ? updateScheduleAppointment.startTime != null &&
            updateScheduleAppointment.startTime != undefined &&
            updateScheduleAppointment.startTime != ""
            ? new Date(
                updateScheduleAppointment.startDate +
                  " " +
                  updateScheduleAppointment.startTime
              )
            : this.global.getDateTimeString(new Date()).toString()
          : updateScheduleAppointment.startTime != null &&
            updateScheduleAppointment.startTime != undefined &&
            updateScheduleAppointment.startTime != ""
          ? new Date(
              updateScheduleAppointment.appointmentDate +
                " " +
                updateScheduleAppointment.startTime
            )
          : this.global.getDateTimeString(new Date()).toString();
  
      let endTime =
        this.checkScheduleType == "parentgrid"
          ? updateScheduleAppointment.endTime != null &&
            updateScheduleAppointment.endTime != undefined &&
            updateScheduleAppointment.endTime != ""
            ? new Date(
                updateScheduleAppointment.endDate +
                  " " +
                  updateScheduleAppointment.endTime
              )
            : this.global.getDateTimeString(new Date()).toString()
          : updateScheduleAppointment.endTime != null &&
            updateScheduleAppointment.endTime != undefined &&
            updateScheduleAppointment.endTime != ""
          ? new Date(
              updateScheduleAppointment.appointmentDate +
                " " +
                updateScheduleAppointment.endTime
            )
          : this.global.getDateTimeString(new Date()).toString();
  
      updateScheduleAppointment.startTime = this.datePipe.transform(
        startTime,
        "yyyy-MM-dd'T'HH:mm:ss"
      );
      updateScheduleAppointment.endTime = this.datePipe.transform(
        endTime,
        "yyyy-MM-dd'T'HH:mm:ss"
      );
      if (
        updateScheduleAppointment.startDate != null &&
        updateScheduleAppointment.startDate != "" &&
        updateScheduleAppointment.startDate != undefined &&
        updateScheduleAppointment.endDate != null &&
        updateScheduleAppointment.endDate != "" &&
        updateScheduleAppointment.endDate != undefined
      ) {
        if (
          new Date(updateScheduleAppointment.startDate).getTime() >
          new Date(updateScheduleAppointment.endDate).getTime()
        ) {
          this.IsButtonDisable = false;
          this.toasterService.error("End date should greater than start date");
          return;
        }
      }
  
      updateScheduleAppointment.startDate =
        updateScheduleAppointment.startDate != null &&
        updateScheduleAppointment.startDate != undefined &&
        updateScheduleAppointment.startDate != ""
          ? this.global.getDateTimeString(this.ListUpdateStartDate)
          : null;
  
      updateScheduleAppointment.endDate =
        updateScheduleAppointment.endDate != null &&
        updateScheduleAppointment.endDate != undefined &&
        updateScheduleAppointment.endDate != ""
          ? this.global.getDateTimeString(this.ListUpdateEndDate)
          : null;
      if (this.scheduleRadioType == "selectdaterange") {
        updateScheduleAppointment.updateStartDate =
          updateScheduleAppointment.startDate != null &&
          updateScheduleAppointment.startDate != undefined &&
          updateScheduleAppointment.startDate != ""
            ? this.global.getDateTimeString(this.startDate)
            : null;
  
        updateScheduleAppointment.updateEndDate =
          updateScheduleAppointment.endDate != null &&
          updateScheduleAppointment.endDate != undefined &&
          updateScheduleAppointment.endDate != ""
            ? this.global.getDateTimeString(this.endDate)
            : null;
      }
  
    
      if (this.checkScheduleType == "parentgrid") {
        updateScheduleAppointment.clientId = this.ListUpdateClientId;
        updateScheduleAppointment.employeeId = this.ListUpdateEmployeeId;
        updateScheduleAppointment.serviceGroupId = this.ListUpdateserviceGroupId;
        updateScheduleAppointment.updateClientId = this.updateAppointmentUpdateBO.clientId.toString();
        updateScheduleAppointment.updateEmployeeId = this.updateAppointmentUpdateBO.employeeId.toString();
        updateScheduleAppointment.updateServiceGroupId = this.updateAppointmentUpdateBO.serviceGroupId.toString();
      }
      if (
        updateScheduleAppointment.frequencyDays == "weekly".toLocaleUpperCase() ||
        updateScheduleAppointment.frequencyDays ==
          "Alternate weeks".toLocaleUpperCase()
      ) {
        updateScheduleAppointment.appointmentDays =
          this.scheduleRadioType == "selectdaterange"
            ? updateScheduleAppointment.appointmentDays
                ?.filter(
                  (multipleAppointments) => multipleAppointments.ischecked == true
                )
                .map((multipleAppointments) => multipleAppointments.value)
            : updateScheduleAppointment.scheduleWeekDays?.split(",");
      } else {
        updateScheduleAppointment.appointmentDays = [];
      }
      updateScheduleAppointment.serviceGroupName = this.serviceGroupName;
      updateScheduleAppointment.frequencyDays = this.frequency;
      updateScheduleAppointment.serviceId = updateScheduleAppointment.serviceId;
      this.ListService.UpdateScheduleAppointment(
        updateScheduleAppointment,
        this.checkScheduleType,
        this.scheduleRadioType
      )
  
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data: any) => {
            this.IsButtonDisable = false;
            if (this.checkScheduleType == "parentgrid") {
              if (data != null && data != undefined && data?.length > 0) {
                this.toasterService.error(data, "Error"), 8000;
                return;
              }
            }
  
            this.toasterService.success("Appointments updated successfully");
            document.getElementById("openUpdateScheduleAppointment").click();
            this.updateAppointmentUpdateBO = new UpdateAppointmentUpdateBO();
            this.ApplyFilter();
            setTimeout(() => {
              this.toasterService.clear();
            }, 8000);
          },
          (err: any) => {
            this.IsButtonDisable = false;
            this.toasterService.error(err, "Error"), 8000;
          }
        );
    }
    // ................................................DeleteAppointment...................................................
    DeleteAppointment() {
      this.IsButtonDisable = true;
      let params = new URLSearchParams();
      params.append("AppointmentId", this.AppointmentId);
      this.ListService.DeleteAppointment(params)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data: any) => {
            this.IsButtonDisable = false;
            this.AppointmentId = null;
            this.DeleteStartDate = "";
            this.DeleteEndDate = "";
            this.toasterService.success("Deleted Successfully!"), 8000;
  
            document.getElementById("openChildDeleteModal").click();
            this.ApplyFilter();
          },
          (err: any) => {
            this.IsButtonDisable = false;
            this.toasterService.error(err);
          }
        );
    }
    // ................................................DeleteVisitSchedule...................................................
    DeleteVisitSchedule() {
      this.IsButtonDisable = true;
      let params = new URLSearchParams();
      params.append("scheduleId", this.visitscheduleId);
      this.ListService.DeleteVisitSchedule(params)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data: any) => {
            this.IsButtonDisable = false;
            this.DeleteType = null;
            this.visitscheduleId = null;
            this.DeleteStartDate = "";
            this.DeleteEndDate = "";
            this.toasterService.success("Deleted Successfully!"), 8000;
            document.getElementById("openParentDeleteModal").click();
            this.ApplyFilter();
          },
          (err: any) => {
            this.IsButtonDisable = false;
            this.toasterService.error(err);
          }
        );
    }
    // ................................................DeleteSelectedDateAppointments...................................................
    DeleteSelectedDateAppointments() {
      this.IsButtonDisable = true;
      if (
        new Date(this.DeleteStartDate).getTime() >
        new Date(this.DeleteEndDate).getTime()
      ) {
        this.IsButtonDisable = false;
        this.toasterService.error("End date should greater than start date");
        return;
      }
  
      let params = new URLSearchParams();
      params.append("visitscheduleId", this.visitscheduleId);
      params.append(
        "startDate",
        this.global.getDateTimeString(this.DeleteStartDate)
      );
      params.append("endDate", this.global.getDateTimeString(this.DeleteEndDate));
      this.ListService.DeleteSelectedDateAppointments(params)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data: any) => {
            this.IsButtonDisable = false;
            this.DeleteType = null;
            this.visitscheduleId = null;
            this.DeleteStartDate = "";
            this.DeleteEndDate = "";
            this.toasterService.success("Deleted Successfully!"), 8000;
            document.getElementById("openParentDeleteModal").click();
            this.ApplyFilter();
          },
          (err: any) => {
            this.IsButtonDisable = false;
            this.toasterService.error(err);
          }
        );
    }
    // ................................................getAuthDetails...................................................
    getAuthDetails(clientId) {
      if (clientId != null && clientId != undefined && clientId != "") {
        let params = new URLSearchParams();
        params.append("clientid", clientId.toString());
        this.EditService.getAuthorization(params)
          .pipe(takeUntil(this.onDestroy$))
          .subscribe((ADetails: any) => {
            ADetails = JSON.parse(ADetails);
            this.AuthorizationDetails = ADetails;
            if (
              ADetails != null &&
              ADetails != undefined &&
              ADetails.length > 10
            ) {
              this.gridAuthDetails.height = "500";
            } else {
              this.gridAuthDetails.height = "auto";
            }
          });
      } else {
        this.AuthorizationDetails = [];
      }
    }
    // ................................................getEmployeeRelationsip...................................................
    getEmployeeRelationsip(clearfields) {
      this.MappedEmployeeDropdown = [];
      if (clearfields == "clear") {
        this.updateAppointmentUpdateBO.employeeId = null;
      }
      if (
        this.updateAppointmentUpdateBO.clientId != null &&
        this.updateAppointmentUpdateBO.clientId != undefined &&
        this.updateAppointmentUpdateBO.clientId != '00000000-0000-0000-0000-000000000000'
      ) {
        let params = new URLSearchParams();
        params.append(
          "clientid",
          this.updateAppointmentUpdateBO.clientId.toString()
        );
        this.EditService.getActiveClientRelationshipEmployeeList(params)
          .pipe(takeUntil(this.onDestroy$))
          .subscribe((data: any) => {
            this.MappedEmployeeDropdown = data;
          });
      } else {
        this.MappedEmployeeDropdown = [];
      }
    }
    // ................................................getClientServiceDropdown...................................................
    getClientServiceDropdown(clearfields) {
      if (clearfields == "clear") {
        this.updateAppointmentUpdateBO.serviceGroupId = null;
      }
      if (
        this.updateAppointmentUpdateBO.clientId != null &&
        this.updateAppointmentUpdateBO.clientId != undefined &&
        this.updateAppointmentUpdateBO.clientId != '00000000-0000-0000-0000-000000000000' &&
        this.updateAppointmentUpdateBO.employeeId != null &&
        this.updateAppointmentUpdateBO.employeeId != '00000000-0000-0000-0000-000000000000' &&
        this.updateAppointmentUpdateBO.employeeId != undefined
      ) {
        let myparams = new URLSearchParams();
        myparams.append(
          "clientId",
          this.updateAppointmentUpdateBO.clientId.toString()
        );
        myparams.append(
          "employeeId",
          this.updateAppointmentUpdateBO.employeeId.toString()
        );
        this.ClientService.getClientServiceDropdown(myparams)
          .pipe(takeUntil(this.onDestroy$))
          .subscribe((data) => {
            this.MappedServiceGroupDropdown = data;
          });
      } else {
        this.MappedServiceGroupDropdown = [];
        this.updateAppointmentUpdateBO.serviceGroupId = null;
      }
    }
    // ................................................selectRadioType...................................................
    selectRadioType() {
      // if (this.scheduleRadioType == "selectdaterange") {
      //   this.startDate =
      //     new Date().getMonth() +
      //     1 +
      //     "/" +
      //     new Date().getDate() +
      //     "/" +
      //     new Date().getFullYear();
      
  
      //   if (
      //     new Date(this.endDate).getTime() < new Date(this.startDate).getTime()
      //   ) {
      //     this.endDate = "";
      //   }
      // } else {
      // }
      this.retainFields("");
    }
    // ................................................getCustomFrequency...................................................
    getCustomFrequency() {
      let params = new URLSearchParams();
      params.append("listCode", "CUSTOMFREQUENCY");
      this.commonservice
        .getStatus(params)
        .subscribe((data: [{ Key: number; Value: string }]) => {
          this.ListScheduleInputProperty.CustomFrequencyList = data;
        });
    }
    // ................................................getFrequencyDays...................................................
    getFrequencyDays() {
      let value = [
        {
          Key: "MON",
          value: "MONDAY",
          ischecked: true,
        },
        {
          Key: "TUE",
          value: "TUESDAY",
          ischecked: true,
        },
        {
          Key: "WED",
          value: "WEDNESDAY",
          ischecked: true,
        },
        {
          Key: "THUR",
          value: "THURSDAY",
          ischecked: true,
        },
        {
          Key: "FRI",
          value: "FRIDAY",
          ischecked: true,
        },
        {
          Key: "SAT",
          value: "SATURDAY",
          ischecked: true,
        },
        {
          Key: "SUN",
          value: "SUNDAY",
          ischecked: true,
        },
      ];
      return value;
    }
    // ................................................checkCustomFrequencyType..................................................
    checkCustomFrequencyType(customFrequencyLid) {
      this.updateAppointmentUpdateBO.appointmentDays = [];
      var customFrequency =
        this.ListScheduleInputProperty.CustomFrequencyList?.filter(
          (fg) => fg.id == customFrequencyLid
        )[0];
      var customFrequencyValue = customFrequency.lovName;
      this.frequency = customFrequency.lovName;
  
      this.updateAppointmentUpdateBO.frequencyDays = customFrequencyValue;
      if (customFrequencyValue != undefined && customFrequencyValue != null) {
        if (
          customFrequencyValue == "weekly".toLocaleUpperCase() ||
          customFrequencyValue == "Alternate weeks".toLocaleUpperCase()
        ) {
          this.updateAppointmentUpdateBO.appointmentDays =
            this.getFrequencyDays();
          this.showDays = true;
        } else {
          this.showDays = false;
        }
      }
    }
    // ................................................retainFields...................................................
    retainFields(schedulerecords) {
      schedulerecords = this.retainFieldList;
      if (this.scheduleRadioType == "enterseries") {
        this.updateAppointmentUpdateBO.startTime = schedulerecords.startTime;
        this.updateAppointmentUpdateBO.endTime = schedulerecords.endTime;
        this.startDate =
          schedulerecords.startDate != null
            ? this.datePipe.transform(schedulerecords.startDate, "MM/dd/yyyy")
            : null;
        this.endDate =
          schedulerecords.endDate != null
            ? this.datePipe.transform(schedulerecords.endDate, "MM/dd/yyyy")
            : null;
        this.updateAppointmentUpdateBO.employeeId =
          schedulerecords.employeeId != null
            ? schedulerecords.employeeId
            : '00000000-0000-0000-0000-000000000000';
        this.frequency = schedulerecords.frequencyDays;
      } else {
        this.updateAppointmentUpdateBO.updateCustomFrequencyLid =
          schedulerecords.customFrequencyLid != null
            ? schedulerecords.customFrequencyLid
            : '00000000-0000-0000-0000-000000000000';
      }
      this.convertingDays(schedulerecords);
    }
    // ................................................convertingDays...................................................
    convertingDays(schedulerecords) {
      let responseAppointmentDays: any = [];
      responseAppointmentDays =
        schedulerecords.scheduleWeekDays != null &&
        schedulerecords.scheduleWeekDays != undefined &&
        schedulerecords.scheduleWeekDays != ""
          ? schedulerecords.scheduleWeekDays?.split(",")
          : null;
      const AppointmentDays: any = [
        "MONDAY",
        "TUESDAY",
        "WEDNESDAY",
        "THURSDAY",
        "FRIDAY",
        "SATURDAY",
        "SUNDAY",
      ];
      this.updateAppointmentUpdateBO.appointmentDays = [];
      if (responseAppointmentDays != null) {
        if (
          schedulerecords.frequencyDays == "weekly".toLocaleUpperCase() ||
          schedulerecords.frequencyDays == "Alternate weeks".toLocaleUpperCase()
        ) {
          this.showDays = true;
        }
        // ApiResponseAppointmentDays -push ischecked as true
        responseAppointmentDays?.forEach((element) => {
          let customFrequency = {
            Key: element?.substr(0, 3),
            value: element,
            ischecked: true,
          };
          this.updateAppointmentUpdateBO.appointmentDays.push(customFrequency);
        });
        // Missing Elements -push ischecked as false
        AppointmentDays.forEach((element) => {
          // indexOf will return value -1 if value not found
          if (responseAppointmentDays.indexOf(element) == -1) {
            let customFrequency = {
              Key: element.substr(0, 3),
              value: element,
              ischecked: false,
            };
            this.updateAppointmentUpdateBO.appointmentDays.push(customFrequency);
          }
        });
        // Sort AppointmentDays according to days
        const daysOrder = {
          MONDAY: 1,
          TUESDAY: 2,
          WEDNESDAY: 3,
          THURSDAY: 4,
          FRIDAY: 5,
          SATURDAY: 6,
          SUNDAY: 7,
        };
        this.updateAppointmentUpdateBO.appointmentDays.sort(
          (comparesortdays1, comparesortdays2) => {
            return (
              daysOrder[comparesortdays1.value] -
              daysOrder[comparesortdays2.value]
            );
          }
        );
      } else {
        // check if customFrequency not having scheduleWeekDays need to push AppointmentDays for weekly and Alternate weeks
        if (
          schedulerecords.frequencyDays == "weekly".toLocaleUpperCase() ||
          schedulerecords.frequencyDays == "Alternate weeks".toLocaleUpperCase()
        ) {
          this.updateAppointmentUpdateBO.appointmentDays = [
            {
              Key: "MON",
              value: "MONDAY",
              ischecked: false,
            },
            {
              Key: "TUE",
              value: "TUESDAY",
              ischecked: false,
            },
            {
              Key: "WED",
              value: "WEDNESDAY",
              ischecked: false,
            },
            {
              Key: "THUR",
              value: "THURSDAY",
              ischecked: false,
            },
            {
              Key: "FRI",
              value: "FRIDAY",
              ischecked: false,
            },
            {
              Key: "SAT",
              value: "SATURDAY",
              ischecked: false,
            },
            {
              Key: "SUN",
              value: "SUNDAY",
              ischecked: false,
            },
          ];
          this.showDays = true;
        } else {
          this.showDays = false;
        }
      }
    }
    public ngOnDestroy(): void {
      this.onDestroy$.next();
    }
  }
  
  